import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AssetService } from 'app/library-assets/services/asset.service';
import { LibraryAsset } from 'app/library-assets/models/library-asset';

@Component({
  selector: 'dac-asset-picker',
  templateUrl: './asset-picker.component.html',
  styleUrls: ['./asset-picker.component.scss']
})
export class AssetPickerComponent implements OnInit {
  private _assets:LibraryAsset[];
  public tags:{label:string,value:string}[];
  public hasLoaded:boolean;
  public loadFailed:boolean;
  private selectedTag:string;
  private assetType:'All'|'article'|'assignment'|null;
  private assetSearch:string;
  @Output() selected = new EventEmitter<LibraryAsset>();

  constructor(private assetService:AssetService) { }

  ngOnInit() {
    this.hasLoaded = false;
    this.loadFailed = false;
    let loaders = [];
    this.tags = [{label:"Filter by tag...", value:""}, {label:"All", value:"All"}];
    Promise.all([this.assetService.getAssets(), this.assetService.getTags()])
    .then((results) => {
      let [assets, tags] = results;
      this.hasLoaded = true;
      this._assets = assets;
      tags.forEach(t => this.tags.push({label:t, value:t}));
    })
    .catch(error => {
      this.loadFailed = true;
      this.hasLoaded = true;
      console.error(error);
    });
  }



  get Assets() {
    return this._assets;
  }

  public searchTitle(title:string) {
    this.assetSearch = title.trim();
    this.runSearch();
  }

  public searchTag(tag:string) {
    if (!tag) {
      this.selectedTag = null;
    }
    else {
      this.selectedTag = tag;
    }
    // we seem to be having a timing issue here on select boxes.
    setTimeout(() => {
      this.runSearch();
    }, 100); 
  }

  public searchType(type:'All'|'article'|'assignment') {
    this.assetType = type;
    // we seem to be having a timing issue here on select boxes.
    setTimeout(() => {
      this.runSearch();
    }, 100); // there is a major timing i
    // this.runSearch();
  }

  private runSearch() {
    this.assetService.searchAssets(this.assetSearch, this.selectedTag, this.assetType)
    .then(assets => {
      this._assets = [];
      assets.forEach(a => {
        this._assets.push(a);
      });
      // this._assets = assets;
    });
  }

  getRouterLink(asset:LibraryAsset) {
    if (asset.type == 'article') {
      return ['/admin/library/articles/' + asset.id];
    }
    else {
      return ['/admin/library/exercises/' + asset.id];
    }
  }

  public pick(asset: LibraryAsset) {
    console.log("selecting ", asset);
    this.selected.emit(asset);
  }


}



// WEBPACK FOOTER //
// ./src/app/library-assets/asset-picker/asset-picker.component.ts